<script>
import { mapState, mapActions } from "vuex";
import Paginate from "vuejs-paginate";

export default {
  components: {
    Paginate,
  },

  computed: {
    ...mapState(["totalResultCount", "pageNumber"]),

    pageNum: {
      get() {
        return this.pageNumber;
      },

      set(newValue) {
        this.handlePaging(newValue);
      },
    },
  },

  methods: {
    ...mapActions(["updatePageNumber", "createUrlPath", "loadMoreResult"]),

    handlePaging(pageNum) {
      this.updatePageNumber(pageNum);
      this.createUrlPath();
      this.loadMoreResult();
    },
  },
};
</script>

<template>
  <div class="c-paging">
    <Paginate
      v-model="pageNum"
      :page-count="Math.ceil(totalResultCount / 20)"
      :page-range="3"
      :margin-pages="2"
      :prev-text="`<i class='icon-right'></i>`"
      :next-text="`<i class='icon-left'></i>`"
      :break-view-class="'paging__dot'"
      :container-class="'paging fa-num'"
      :page-class="'paging__item'"
      :prev-class="'paging__item'"
      :next-class="'paging__item'"
    >
      <template slot="breakViewContent">
        <span class="paging__dot-text hide-in-desktop">
          <span class="ml--1">{{ pageNum }}</span>
          از
          <span class="mr--1">{{ Math.ceil(totalResultCount / 20) }}</span>
        </span>

        <span class="hide-in-not-desktop">
          ...
        </span>
      </template>
    </Paginate>
  </div>
</template>